import { Link } from "react-router-dom";
import type { DraftDTO } from "@app/shared";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { StatusBadge } from "./StatusBadge";
import { ImagePreview } from "./ImagePreview";
import { draftImageUrl } from "../lib/api";
import { formatDateTime } from "../lib/format";

/** Compact preview of a single draft, linking through to its detail page. */
export function DraftCard({ draft }: { draft: DraftDTO }) {
  return (
    <Link to={`/drafts/${draft.id}`} className="group block">
      <Card className="overflow-hidden transition-shadow group-hover:shadow-md">
        <ImagePreview src={draftImageUrl(draft)} className="rounded-none border-0 border-b" />
        <CardContent className="space-y-2 p-4">
          <div className="flex items-center justify-between gap-2">
            <StatusBadge status={draft.status} />
            {draft.pillar ? (
              <Badge variant="teal">{draft.pillar}</Badge>
            ) : (
              <Badge variant="coral">Greeting</Badge>
            )}
          </div>
          <p className="line-clamp-2 text-sm font-medium text-slate-900">
            {draft.headline ?? "(no headline)"}
          </p>
          <p className="text-xs text-slate-500">
            {formatDateTime(draft.targetPublishAt)}
            {draft.suggestedTime ? ` · ${draft.suggestedTime}` : ""}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
